import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { SectionLinksWrapper, SectionLink, PageWrapper, Headline } from 'libs/ui';
import { components } from './components';

export const Section = (props) => {
  const { match, sectionName, subsectionList, subRoutes } = props;
  const { t } = useTranslation();
  const location = useLocation();
  const currentLocation = location.pathname;
  const withSubsections = Array.isArray(subsectionList) && subsectionList.length > 0;

  /**
   * get subsections links
   * @returns
   */
  const getLinks = () => {
    if (!withSubsections) {
      return null;
    }

    const items = subsectionList.filter((el) => !el['hidden'] || (el['hidden'] && currentLocation.indexOf(el.path) !== -1));
    const cl = items.length > 7 ? 'double' : '';
    const links = items.map((subsection, index) => {
      return (
        <SectionLink key={index} to={subsection.path}>
          {t('sections.' + subsection.name)}
        </SectionLink>
      );
    });
    return <SectionLinksWrapper className={cl}>{links}</SectionLinksWrapper>;
  };

  /**
   * get subsroutes routes
   * @returns
   */
  const getRoutes = () => {
    const subs = getRouteArray(subRoutes);
    const subsectionRoutes = getRouteArray(subsectionList);
    return subs.concat(subsectionRoutes);
  };

  /**
   * get routes array
   * @param {*} routes
   * @returns
   */
  const getRouteArray = (items) => {
    if (!Array.isArray(items) || items.length === 0) {
      return [];
    }
    return items.map((el, idx) => {
      return <Route key={idx} path={el.path} component={components[el.id]} exact={el.exact} />;
    });
  };

  /**
   * default redirect for section
   * @returns
   */
  const getRedirectPath = () => {
    if (subsectionList?.length > 0) {
      return subsectionList[0].path;
    }
    return match.path;
  };

  const defaultRedirect = getRedirectPath();
  const links = getLinks();
  const routes = getRoutes();

  return (
    <PageWrapper>
      {withSubsections && <Headline>{t('sections.' + sectionName)}</Headline>}
      {links}
      <Switch>
        {routes}
        <Redirect to={defaultRedirect} />
      </Switch>
    </PageWrapper>
  );
};
